import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from '@ifeng-fe/three_terminal/es/pc/comment/index.js';
import TopicTitle from '../../../components/topicTitle';

class TopicComment extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        docTitle: PropTypes.string,
        commentUrl: PropTypes.string,
        pcUrl: PropTypes.string,
        skey: PropTypes.string,
    };

    render() {
        const {
            content: { moduleIndex, title },
            docTitle,
            commentUrl,
            pcUrl,
            skey,
        } = this.props;

        const commentConfig = {
            docUrl: commentUrl || 'ucms_', // 文章单页的页面地址
            docTitle, // 文章的标题
            skey, // 文章评论的skey，这个是在后端生成好后给到前端的
            speUrl: '', // 兼容以后的专题评论
            pcUrl, // 文章pc的页面地址
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            order: 'both', // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
            options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
            recentLimit: 2, // 最近评论数量
            recentReplyLimit: 3, // 最近评论数量显示回复的楼层
        };

        return (
            <div className={styles.comment_box}>
                {title !== '' ? <TopicTitle moduleIndex={moduleIndex} title={title} /> : ''}
                <LazyLoad>
                    <Comment articleInfo={commentConfig} />
                </LazyLoad>
            </div>
        );
    }
}

export default errorBoundary(TopicComment);
